'use client'
import React from 'react'
import { Route } from '@/routers/routes'
import { FaEnvelope, FaHouse, FaNewspaper } from 'react-icons/fa6'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { isActiveLink } from '@/library/utils/links'
import { translateIt } from '@/data/translations'
import { LANGUAGE } from '@/data/constants'

export default function InstrumentNavigation(props) {
  const { item, className = "" } = props
  const pathname = usePathname()
  const linkClasses = 'flex text-sm items-center gap-2 px-5 py-1 hover:bg-primary-400 hover:text-white hover:scale-105 transition-all duration-300 rounded-full'
  const isActiveClasses = 'text-primary bg-primary font-medium text-white'
  const isNotActiveClasses = 'text-primary-300  bg-zink-900'

  const routes = [
    {
      name: translateIt(LANGUAGE, 'overview'),
      href: Route.instrumentDetail(item),
      Icon: FaHouse,
      match: 'exact',
    },
    {
      name: translateIt(LANGUAGE, 'articles'),
      href: Route.instrumentDetailInsightList(item),
      Icon: FaNewspaper,
      match: 'startsWith',
    },
    {
      name: translateIt(LANGUAGE, 'disclosures'),
      href: Route.instrumentDetailDisclosureList(item),
      Icon: FaEnvelope,
      match: 'startsWith',
    },
  ]

  return (
    <div className={`bg-white px-2 md:px-8 ${className}`}>
      <ul className="flex flex-row justify-center md:justify-start gap-1 md:gap-5 shadow-slate-400">
        {routes.map((route) => {
          const isActive = isActiveLink(pathname, route.href, route.match)
          return (
            <li key={route.name}>
              <Link href={route.href} className={`${linkClasses} ${isActive ? isActiveClasses : isNotActiveClasses}`}>
                <route.Icon /> {route.name}
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
